import { useState } from 'react';

const faqs = [
  {
    question: '蜜桃电影提供哪些类型的影片推荐？',
    answer: '蜜桃电影覆盖爱情、喜剧、动作、悬疑、科幻、动画、恐怖、纪录片等八大主流类型，每一部推荐影片都经过编辑团队精心筛选，确保为您提供高质量的观影选择。我们持续更新片单，让您不错过任何一部好片。',
  },
  {
    question: '蜜桃电影是否需要注册或付费？',
    answer: '蜜桃电影是一个完全免费的影片推荐平台，无需注册即可浏览所有推荐内容。我们通过专业的影评文章和精选片单，帮助您在海量影片中快速找到值得观看的好电影。我们不提供影片播放服务，仅做推荐和介绍。',
  },
  {
    question: '蜜桃电影的推荐标准是什么？',
    answer: '我们的编辑团队基于多个维度进行影片筛选：影片质量（评分、获奖情况）、观众口碑（真实用户评价）、类型代表性、以及当下热度。我们坚持独立、客观的推荐原则，确保每一部推荐都经得起推敲。',
  },
  {
    question: '如何找到适合自己口味的电影？',
    answer: '您可以通过首页的分类入口浏览不同类型的影片，也可以查看我们的"精选推荐"栏目发现高分佳作。如果您喜欢深度了解电影，推荐阅读我们的影评文章，每篇文章都会从多个角度分析影片，帮助您做出选择。',
  },
  {
    question: '蜜桃电影的影评文章多久更新一次？',
    answer: '我们保持每周至少更新2-3篇高质量影评文章的更新频率。在热门档期（如春节档、暑期档、国庆档），我们会加大更新力度，确保为您带来最新、最全面的观影参考。',
  },
  {
    question: '我可以向蜜桃电影推荐影片吗？',
    answer: '当然可以！我们非常欢迎观众推荐好片。您可以通过"关于我们"页面的联系表单提交您的推荐，我们的编辑团队会认真评估每一份推荐。优秀的推荐还有机会出现在我们的精选片单中。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于蜜桃电影，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full px-5 py-4 text-left flex items-center justify-between gap-3 cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-medium text-foreground-900 text-sm md:text-base pr-4">
                  {faq.question}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${
                      openIndex === index ? 'subtract' : 'add'
                    }-line text-lg text-foreground-500 transition-transform duration-300`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}